import { v1ApiClient } from '@/services';
import type {
  PathParams,
  RequestBody,
  ResponseBody,
} from '@/shared/api/generated';

type UpdateNotificationPath = '/v1/notifications/{notification_id}';

type UpdateNotificationParams = PathParams<UpdateNotificationPath, 'put'> &
  RequestBody<UpdateNotificationPath, 'put'>;
type UpdateNotificationResponse = ResponseBody<UpdateNotificationPath, 'put'>;

/**
 * 알림 수정
 */
export const updateNotification = ({
  notification_id,
  ...body
}: UpdateNotificationParams): Promise<UpdateNotificationResponse> => {
  return v1ApiClient
    .put(`/notifications/${notification_id}`, body)
    .then((res) => res.data);
};
